var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nft (3) 1",
    clipPath: "url(#clip0_3927_176577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.1266 11.8172C63.1266 -8.68491 37.3111 5.56084 24.2927 4.98472C19.3952 4.76797 8.01646 -3.78916 3.40946 2.01559C-2.51929 9.48572 15.467 20.6592 15.2817 30.1943C15.117 38.6763 10.0527 46.9145 15.7353 55.0426C26.2992 70.1527 46.9785 65.09 46.9785 47.7582C46.9785 25.6955 63.1266 23.1486 63.1266 11.8172Z",
    fill: "url(#paint0_linear_3927_176577)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.1,
    d: "M58.0378 52.9082L49.1248 43.1838C48.7383 42.7621 48.3023 42.3937 47.8293 42.0846L46.5749 39.5516C45.854 38.0961 44.595 36.9783 43.0643 36.4352L39.7728 35.2672C38.3689 34.7691 37.0314 34.1007 35.7901 33.2771L32.8986 31.3585H36.2911C37.8276 31.3585 39.2593 30.5318 40.0274 29.2013L41.3 26.9972L45.3293 29.5593C45.3026 29.683 45.2878 29.8108 45.2878 29.9425C45.2878 30.9413 46.0975 31.7512 47.0965 31.7512C48.0955 31.7512 48.9053 30.9413 48.9053 29.9425C48.9053 28.9436 48.0954 28.1337 47.0965 28.1337C46.6843 28.1337 46.3055 28.2732 46.0013 28.5055L41.9255 25.9138L43.6516 22.9241C43.928 22.4452 44.1034 21.9245 44.1808 21.3921H48.9135V22.8872C48.9135 23.0242 48.9931 23.1483 49.1161 23.2057L52.4786 24.7786C52.5255 24.8008 52.5759 24.8126 52.6274 24.8126H52.6333L52.6334 24.812C52.6829 24.8111 52.7311 24.8001 52.7761 24.7787L56.1386 23.2058C56.2616 23.1485 56.3413 23.0243 56.3413 22.8873V18.6465C56.3413 18.5752 56.3186 18.5083 56.2803 18.4515L56.2815 18.4508C56.2799 18.4483 56.2774 18.4467 56.2758 18.4443C56.274 18.442 56.2728 18.4392 56.271 18.4368L56.2694 18.4372C56.2353 18.3915 56.1915 18.3533 56.1386 18.328L52.7761 16.7551C52.6824 16.7106 52.5724 16.7106 52.4786 16.7551L49.1161 18.328C49.0605 18.3547 49.0141 18.3948 48.9794 18.444L48.9791 18.4438C48.9789 18.4442 48.9786 18.4447 48.9784 18.4452C48.9769 18.4473 48.9748 18.4488 48.9733 18.451L48.9745 18.4516C48.9356 18.5086 48.9135 18.5758 48.9135 18.6466V20.1423H44.1806C44.1031 19.61 43.9279 19.0891 43.6514 18.6102L41.9254 15.6207L46.0011 13.0291C46.3054 13.2613 46.6841 13.4007 47.0963 13.4007C48.0951 13.4007 48.905 12.591 48.905 11.592C48.905 10.5931 48.0951 9.7832 47.0963 9.7832C46.0974 9.7832 45.2875 10.593 45.2875 11.592C45.2875 11.7236 45.3024 11.8515 45.329 11.9751L41.2998 14.5372L40.0273 12.3331C39.259 11.0025 37.8274 10.176 36.2909 10.176H29.0426C27.5061 10.176 26.0745 11.0026 25.3065 12.3331L24.0339 14.5373L20.0046 11.9752C20.0314 11.8516 20.0461 11.7236 20.0461 11.5921C20.0461 10.5932 19.2364 9.78333 18.2374 9.78333C17.2384 9.78333 16.4286 10.5931 16.4286 11.5921C16.4286 12.5911 17.2384 13.4008 18.2374 13.4008C18.6496 13.4008 19.0284 13.2613 19.3325 13.0292L23.4083 15.621L21.6821 18.6106C21.4056 19.0895 21.2304 19.6102 21.1529 20.1426H16.4201V18.6468C16.4201 18.5756 16.3974 18.5087 16.3591 18.4518L16.3604 18.4512C16.3588 18.4487 16.3563 18.4471 16.3545 18.4447C16.3528 18.4423 16.3515 18.4396 16.3498 18.4372L16.3481 18.4376C16.314 18.3918 16.2703 18.3537 16.2174 18.3283L12.8549 16.7555C12.7611 16.711 12.6511 16.711 12.5574 16.7555L9.19488 18.3283C9.13913 18.3551 9.09288 18.3952 9.05813 18.4443L9.05788 18.4442C9.05763 18.4446 9.05738 18.4451 9.057 18.4456C9.0555 18.4477 9.05338 18.4492 9.052 18.4513L9.05325 18.452C9.01425 18.509 8.99225 18.5762 8.99225 18.647V22.8878C8.99225 23.0248 9.07188 23.149 9.19488 23.2063L12.5574 24.7792C12.6043 24.8015 12.6546 24.8132 12.7061 24.8132H12.712L12.7121 24.8126C12.7615 24.8117 12.8099 24.8007 12.8549 24.7793L16.2174 23.2065C16.3404 23.1491 16.42 23.025 16.42 22.888V21.3928H21.1528C21.2303 21.9252 21.4055 22.4461 21.682 22.925L23.408 25.9146L19.3323 28.5062C19.028 28.274 18.6493 28.1345 18.237 28.1345C17.238 28.1345 16.4283 28.9442 16.4283 29.9432C16.4283 30.9422 17.238 31.752 18.237 31.752C19.2359 31.752 20.0458 30.9421 20.0458 29.9432C20.0458 29.8117 20.0309 29.6837 20.0043 29.5601L24.0335 26.998L25.306 29.2021C25.6253 29.7552 26.0604 30.2195 26.5689 30.5752C26.2659 31.8103 26.6815 33.1708 27.7594 34.011L34.1316 38.9776L26.2291 38.2061C26.0163 36.6727 24.6916 35.4948 23.095 35.5147C22.3623 35.5238 21.7798 36.1367 21.7798 36.8695V37.7718L20.5814 37.6548L18.9495 36.6363C18.929 34.9281 17.5386 33.5495 15.8255 33.5495C15.6585 33.5495 15.4994 33.5826 15.3533 33.6411C15.3463 31.9211 13.9501 30.529 12.2286 30.529C11.5343 30.529 10.9709 31.0861 10.9591 31.7777C9.5525 31.3542 7.98225 31.9767 7.28463 33.3561C6.95375 34.0102 7.17625 34.8087 7.7975 35.1976L10.9578 37.1758L10.9576 39.7062C10.9576 40.599 11.5141 41.3971 12.3519 41.7055L14.5545 42.5166V42.7267C14.5545 43.6194 15.111 44.4176 15.9488 44.7261L24.5841 47.0505L25.214 47.7993C25.4773 48.1123 25.8581 48.3025 26.2665 48.3248L35.6164 48.8357L45.3989 62.0663C45.5851 62.3182 45.9284 62.3936 46.2026 62.2423C47.8213 61.3503 53.2326 58.2231 57.9993 53.7918C58.2525 53.5561 58.2708 53.1625 58.0378 52.9082Z",
    fill: "#0274B5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.2373 26.9425L47.0961 8.5918",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M47.0961 26.9425L18.2373 8.5918",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M43.0638 33.4364L39.7723 32.2684C38.3684 31.7702 37.0309 31.1019 35.7896 30.2782L29.0588 25.812C28.5406 25.4682 27.8486 25.5575 27.4348 26.0216L27.3198 26.1506C26.0333 27.5932 26.235 29.8231 27.7596 31.0114L34.1319 35.978L20.5816 34.6552L11.7128 29.1199C10.1601 28.1509 8.11063 28.7231 7.28463 30.3564C6.95375 31.0105 7.17625 31.809 7.7975 32.1979L17.2414 38.1094L27.3509 42.3001L43.8665 46.2867L48.0645 39.5619L46.5744 36.5529C45.8536 35.0972 44.5945 33.9795 43.0638 33.4364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M43.0638 33.4364L39.7723 32.2684C38.3684 31.7702 37.0309 31.1019 35.7896 30.2782L29.0588 25.812C28.5406 25.4682 27.8486 25.5575 27.4348 26.0216L27.3198 26.1506C26.0333 27.5932 26.235 29.8231 27.7596 31.0114L34.1319 35.978L20.5816 34.6552L11.7128 29.1199C10.1601 28.1509 8.11063 28.7231 7.28463 30.3564C6.95375 31.0105 7.17625 31.809 7.7975 32.1979L17.2414 38.1094L27.3509 42.3001L43.8665 46.2867L48.0645 39.5619L46.5744 36.5529C45.8536 35.0972 44.5945 33.9795 43.0638 33.4364Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.9337 36.5069L15.5747 35.9815L15.3519 30.6543C15.3519 28.9284 13.9528 27.5293 12.2269 27.5293C11.5252 27.5293 10.9563 28.0982 10.9563 28.7999L10.9561 36.7065C10.9561 37.5993 11.5126 38.3974 12.3503 38.7059L16.9337 40.3937V36.5069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.9337 36.5069L15.5747 35.9815L15.3519 30.6543C15.3519 28.9284 13.9528 27.5293 12.2269 27.5293C11.5252 27.5293 10.9563 28.0982 10.9563 28.7999L10.9561 36.7065C10.9561 37.5993 11.5126 38.3974 12.3503 38.7059L16.9337 40.3937V36.5069Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M29.1878 45.2891L15.948 41.7253C15.1102 41.4168 14.5536 40.6187 14.5537 39.726L14.554 31.8193C14.554 31.1176 15.1228 30.5488 15.8246 30.5488C17.5505 30.5488 18.9496 31.948 18.9496 33.6738V37.6542L26.2588 39.3998L29.1878 45.2891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M29.1878 45.2891L15.948 41.7253C15.1102 41.4168 14.5536 40.6187 14.5537 39.726L14.554 31.8193C14.554 31.1176 15.1228 30.5488 15.8246 30.5488C17.5505 30.5488 18.9496 31.948 18.9496 33.6738V37.6542L26.2588 39.3998L29.1878 45.2891Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M49.1248 40.1857C48.1249 39.0949 46.7973 38.3561 45.3406 38.0952C43.7354 37.8077 41.3295 37.5999 38.0335 37.874C34.0711 38.2036 29.9435 41.4854 29.9435 41.4854L26.2603 39.4015V35.6406C26.2603 33.9015 24.8396 32.4942 23.0955 32.5159C22.3628 32.525 21.7803 33.1379 21.7803 33.8706V40.177C21.7803 40.5257 21.9034 40.8632 22.1278 41.1301L25.2145 44.8004C25.4778 45.1134 25.8586 45.3035 26.267 45.3259L35.6169 45.8367L45.3994 59.0674C45.5856 59.3192 45.9289 59.3946 46.2033 59.2434C47.8219 58.3514 53.2333 55.2241 57.9999 50.7929C58.2525 50.558 58.2708 50.1644 58.0378 49.9101L49.1248 40.1857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M38.0335 37.874C34.0712 38.2035 29.9435 41.4854 29.9435 41.4854L26.2603 39.4015V35.6406C26.2603 33.9015 24.8396 32.4941 23.0955 32.5159C22.3628 32.525 21.7803 33.1379 21.7803 33.8706V40.177C21.7803 40.5257 21.9034 40.8632 22.1278 41.1301L25.2145 44.8004C25.4778 45.1134 25.8586 45.3035 26.267 45.3259L35.6169 45.8368L45.3994 59.0674C45.5856 59.3193 45.9289 59.3946 46.2031 59.2434C47.8218 58.3514 53.2331 55.2241 57.9998 50.7929C58.2524 50.558 58.2707 50.1644 58.0377 49.9101L55.034 46.633",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M52.5222 43.8948L49.123 40.1862C48.1231 39.0953 46.7955 38.3566 45.3389 38.0957",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M35.6162 45.8355L39.559 46.0129C40.1272 46.0385 40.6975 45.9724 41.2397 45.8006C42.3508 45.4486 44.0447 44.583 45.1775 42.4688",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M44.3115 17.7676H48.9135",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M16.4209 17.7676H21.0229",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M53.3542 16.8204L52.6328 21.8143H52.627C52.5755 21.8143 52.5251 21.8026 52.4782 21.7803L49.1157 20.2074C48.9927 20.1501 48.9131 20.0259 48.9131 19.8888V15.6479C48.9131 15.5742 48.9365 15.5039 48.9787 15.4453L53.3542 16.8204Z",
    fill: "#0274B5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M56.3418 15.647V19.8879C56.3418 20.0249 56.2622 20.149 56.1392 20.2065L52.7767 21.7794C52.7298 21.8016 52.6794 21.8134 52.6279 21.8134V16.1894L56.2714 15.4375C56.3161 15.4971 56.3418 15.5698 56.3418 15.647Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M56.2799 15.4519L52.6258 17.1607L48.9717 15.4519C49.0068 15.3992 49.0561 15.357 49.1146 15.3289L52.4771 13.756C52.5708 13.7115 52.6808 13.7115 52.7746 13.756L56.1371 15.3289C56.1956 15.357 56.2448 15.3993 56.2799 15.4519Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M56.2798 15.4524L56.2811 15.4518C56.2795 15.4493 56.277 15.4477 56.2753 15.4453C56.2736 15.4429 56.2723 15.4402 56.2706 15.4378L56.269 15.4382C56.2348 15.3924 56.1911 15.3543 56.1382 15.3289L52.7757 13.756C52.682 13.7115 52.572 13.7115 52.4782 13.756L49.1157 15.3289C49.0601 15.3557 49.0137 15.3958 48.979 15.4449L48.9787 15.4448C48.9785 15.4452 48.9782 15.4457 48.9778 15.4462C48.9763 15.4483 48.9742 15.4498 48.9728 15.4519L48.9741 15.4525C48.9352 15.5095 48.9131 15.5768 48.9131 15.6475V19.8884C48.9131 20.0254 48.9927 20.1495 49.1157 20.207L52.4782 21.7799C52.5251 21.8022 52.5755 21.8139 52.627 21.8139H52.6328L52.633 21.8133C52.6823 21.8124 52.7307 21.8014 52.7757 21.78L56.1382 20.2072C56.2612 20.1498 56.3408 20.0257 56.3408 19.8885V15.6477C56.3408 15.5762 56.3181 15.5093 56.2798 15.4524Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M13.4323 16.8204L12.711 21.8143H12.7051C12.6536 21.8143 12.6032 21.8026 12.5563 21.7803L9.19384 20.2074C9.07084 20.1501 8.99121 20.0259 8.99121 19.8888V15.6479C8.99121 15.5742 9.01459 15.5039 9.05684 15.4453L13.4323 16.8204Z",
    fill: "#0274B5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M16.4199 15.647V19.8879C16.4199 20.0249 16.3403 20.149 16.2173 20.2065L12.8548 21.7794C12.8079 21.8016 12.7576 21.8134 12.7061 21.8134V16.1894L16.3496 15.4375C16.3942 15.4971 16.4199 15.5698 16.4199 15.647Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M16.3581 15.4519L12.7039 17.1607L9.0498 15.4519C9.08493 15.3992 9.13418 15.357 9.19268 15.3289L12.5552 13.756C12.6489 13.7115 12.7589 13.7115 12.8527 13.756L16.2152 15.3289C16.2738 15.357 16.3229 15.3993 16.3581 15.4519Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M16.358 15.4524L16.3592 15.4518C16.3576 15.4493 16.3551 15.4477 16.3535 15.4453C16.3517 15.4429 16.3505 15.4402 16.3487 15.4378L16.3471 15.4382C16.313 15.3924 16.2692 15.3543 16.2163 15.3289L12.8538 13.756C12.7601 13.7115 12.6501 13.7115 12.5563 13.756L9.19384 15.3289C9.13821 15.3557 9.09184 15.3958 9.05709 15.4449L9.05684 15.4448C9.05659 15.4452 9.05634 15.4457 9.05596 15.4462C9.05446 15.4483 9.05234 15.4498 9.05096 15.4519L9.05221 15.4525C9.01321 15.5095 8.99121 15.5768 8.99121 15.6475V19.8884C8.99121 20.0254 9.07084 20.1495 9.19384 20.207L12.5563 21.7799C12.6032 21.8022 12.6536 21.8139 12.7051 21.8139H12.711L12.7111 21.8133C12.7605 21.8124 12.8088 21.8014 12.8538 21.78L16.2163 20.2072C16.3393 20.1498 16.419 20.0257 16.419 19.8885V15.6477C16.419 15.5762 16.3963 15.5093 16.358 15.4524Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M29.0411 28.3587C27.5046 28.3587 26.0729 27.532 25.3048 26.2015L21.6807 19.9244C20.9124 18.5938 20.9124 16.9408 21.6807 15.6103L25.3049 9.33291C26.0731 8.00241 27.5047 7.17578 29.0411 7.17578H36.2893C37.8258 7.17578 39.2574 8.00241 40.0257 9.33291L43.6497 15.61C44.4179 16.9407 44.4179 18.5937 43.6498 19.9242L40.0256 26.2015C39.2574 27.532 37.8258 28.3587 36.2893 28.3587H29.0411Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M30.7342 7.17578H29.041C27.5045 7.17578 26.0728 8.00241 25.3048 9.33291L21.6806 15.6103C20.9125 16.9408 20.9125 18.5938 21.6806 19.9244L25.3047 26.2015C26.0728 27.5322 27.5045 28.3587 29.041 28.3587H36.2892C37.8257 28.3587 39.2573 27.532 40.0255 26.2015L43.6497 19.9242C44.4178 18.5937 44.4178 16.9407 43.6496 15.61L40.0256 9.33291C39.2573 8.00228 37.8257 7.17578 36.2892 7.17578H34.4456",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M36.2911 10.3008H29.0428C28.6179 10.3008 28.2254 10.5274 28.0129 10.8954L24.3888 17.1727C24.1764 17.5405 24.1764 17.9939 24.3888 18.3618L28.0129 24.639C28.2253 25.0069 28.6179 25.2337 29.0428 25.2337H36.2911C36.716 25.2337 37.1085 25.007 37.321 24.639L40.9451 18.3618C41.1575 17.9939 41.1575 17.5405 40.9451 17.1727L37.321 10.8953C37.1086 10.5274 36.716 10.3008 36.2911 10.3008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M35.6259 12.9375H32.0615V22.5988",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M29.8777 22.5988L27.0889 17.7681L29.8777 18.8847V12.9375",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M32.0615 17.5996H33.4135",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M35.624 15.2422V22.5964",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M34.2256 15.1758H37.0253L38.299 17.4423",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M47.0968 10.4007C48.0958 10.4007 48.9056 9.5909 48.9056 8.59195C48.9056 7.59301 48.0958 6.7832 47.0968 6.7832C46.0979 6.7832 45.2881 7.59301 45.2881 8.59195C45.2881 9.5909 46.0979 10.4007 47.0968 10.4007Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M18.2375 28.7523C19.2364 28.7523 20.0462 27.9425 20.0462 26.9435C20.0462 25.9446 19.2364 25.1348 18.2375 25.1348C17.2385 25.1348 16.4287 25.9446 16.4287 26.9435C16.4287 27.9425 17.2385 28.7523 18.2375 28.7523Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M18.2375 10.4007C19.2364 10.4007 20.0462 9.5909 20.0462 8.59195C20.0462 7.59301 19.2364 6.7832 18.2375 6.7832C17.2385 6.7832 16.4287 7.59301 16.4287 8.59195C16.4287 9.5909 17.2385 10.4007 18.2375 10.4007Z",
    fill: "#77CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M47.0968 28.7523C48.0958 28.7523 48.9056 27.9425 48.9056 26.9435C48.9056 25.9446 48.0958 25.1348 47.0968 25.1348C46.0979 25.1348 45.2881 25.9446 45.2881 26.9435C45.2881 27.9425 46.0979 28.7523 47.0968 28.7523Z",
    fill: "#77CEFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M47.0968 10.4007C48.0958 10.4007 48.9056 9.5909 48.9056 8.59195C48.9056 7.59301 48.0958 6.7832 47.0968 6.7832C46.0979 6.7832 45.2881 7.59301 45.2881 8.59195C45.2881 9.5909 46.0979 10.4007 47.0968 10.4007Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M18.2375 28.7523C19.2364 28.7523 20.0462 27.9425 20.0462 26.9435C20.0462 25.9446 19.2364 25.1348 18.2375 25.1348C17.2385 25.1348 16.4287 25.9446 16.4287 26.9435C16.4287 27.9425 17.2385 28.7523 18.2375 28.7523Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M18.2375 10.4007C19.2364 10.4007 20.0462 9.5909 20.0462 8.59195C20.0462 7.59301 19.2364 6.7832 18.2375 6.7832C17.2385 6.7832 16.4287 7.59301 16.4287 8.59195C16.4287 9.5909 17.2385 10.4007 18.2375 10.4007Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M47.0968 28.7523C48.0958 28.7523 48.9056 27.9425 48.9056 26.9435C48.9056 25.9446 48.0958 25.1348 47.0968 25.1348C46.0979 25.1348 45.2881 25.9446 45.2881 26.9435C45.2881 27.9425 46.0979 28.7523 47.0968 28.7523Z",
    stroke: "#0274B5",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M11.5186 46.4766C12.1744 46.4766 12.7061 45.9449 12.7061 45.2891C12.7061 44.6332 12.1744 44.1016 11.5186 44.1016C10.8627 44.1016 10.3311 44.6332 10.3311 45.2891C10.3311 45.9449 10.8627 46.4766 11.5186 46.4766Z",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M12.1475 7.05469C12.8033 7.05469 13.335 6.52303 13.335 5.86719C13.335 5.21135 12.8033 4.67969 12.1475 4.67969C11.4916 4.67969 10.96 5.21135 10.96 5.86719C10.96 6.52303 11.4916 7.05469 12.1475 7.05469Z",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M55.5029 36.707L54.0654 35.2695L52.628 36.707L54.0654 38.1444L55.5029 36.707Z",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M39.7373 58.7285L38.2998 57.291L36.8624 58.7285L38.2998 60.1659L39.7373 58.7285Z",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M18.7216 49.955L17.2842 48.5176L15.8467 49.955L17.2842 51.3925L18.7216 49.955Z",
    stroke: "#77CEFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3927_176577",
    x1: 6.94027,
    y1: 46.7769,
    x2: 55.3831,
    y2: -1.66595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1DDFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6C4FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3927_176577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNft);
export default __webpack_public_path__ + "static/media/nft.e4066f7868bfeb45272905ad9ad57137.svg";
export { ForwardRef as ReactComponent };